export const TEST_ID = 'johnDeereExportModalBody';
